import { ISearchPriceRange } from '@shared/types/search';

export const getPriceRangeQueryValue = (priceRange: ISearchPriceRange): string | undefined => {
  return `$${priceRange.minPrice}-$${priceRange.maxPrice}`;
};
